<template>
  <m-dialog ref="dlg" @save="save" title="Ubah Saldo Cuti">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="10" md="7" lg="7" xl="7" class="mb-5">
        <div class="body-1 black--text">Kelola Saldo Cuti</div>
        <v-form @submit.prevent data-vv-scope="form" lazy-validation>
          <v-row wrap>
            <v-col cols="12" md="12" sm="12">
              <v-list>
                <v-list-item>
                  <v-list-item-avatar size="50" color="primary lighten-4">
                    <v-icon color="primary">mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="primary--text headline">{{ getDeepObj(detail, 'nama') || getDeepObj(detail, 'users.nama') }}</div>
                    <div class="black--text">
                      Minimal Masa Kerja <b>{{ getDeepObj(detail, 'masa_kerja') || 0 }} Bulan</b>
                    </div>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip color="warning">{{ getDeepObj(detail, 'kategori') || getDeepObj(detail, 'cuti_kategori.nama') }}</v-chip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <v-alert type="info" text dense>
                Jika Anda melakukan proses sisa cuti. Maka sistem akan mengacu pada hasil inputan Anda
                ini. Tidak mengacu pada perhitungan (generate) yang dilakukan sistem sebelumnya
              </v-alert>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <label class="caption mb-2 primary--text"> Sisa Cuti </label>
              <v-text-field
                autofocus
                dense
                single-line
                outlined
                class="mr-5"
                type="number"
                label="Jumlah Sisa Cuti"
                v-model="form.jml_sisa"
                hint="Masukkan Jumlah Sisa Cuti"
                data-vv-name="jml_sisa"
                data-vv-as="Saldo Cuti"
                v-validate="'required|min_value:0'"
                :error-messages="errors.collect('form.jml_sisa')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <label class="caption mb-2 primary--text"> Jatah Cuti </label>
              <div class="primary--text text-h6 mt-1">{{ Number(getDeepObj(detail, 'jumlah') || 0) }} Hari</div>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      form: {},
      detail: {},
    }
  },
  methods: {
    open(detail) {
      this.reset()
      this.$validator.reset()
      this.detail = detail
      this.initForm(detail)

      this.$refs.dlg.open()
    },
    initForm(value) {
      this.$set(this.form, 'jml_sisa', Number(this.getDeepObj(value, 'sisa')))
    },
    reset() {
      this.form = {}
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.$store
            .dispatch('saldoCuti/update', {
              organisasi_id: this.organisasi_id,
              obj: {
                params: {
                  jml_sisa: Number(this.getDeepObj(this.form, 'jml_sisa'))
                },
                id: this.getDeepObj(this.detail, 'cuti_saldo_id'),
              },
            })
            .then(() => {
              this.$success('Saldo berhasil di perbarui')
              this.$refs.dlg.resolve()
              this.$emit('reload')
            })
        })
    },
  },
}
</script>
